import gql from "graphql-tag";

const getAllAppConfigReminder = gql`
  query {
    getAllAppConfigReminder {
      id
      module
      daysAddedDefaultInDeadline
      remindBefore
      createdAt
      updatedAt
    }
  }
`;

const getAppConfigReminderByModuleName = gql`
  query GetAppConfigReminderByModuleName($moduleName: String!) {
    getAppConfigReminderByModuleName(moduleName: $moduleName) {
      module
      daysAddedDefaultInDeadline
      remindBefore
    }
  }
`;

export default { getAllAppConfigReminder, getAppConfigReminderByModuleName };
